import { Button, IconArrowUp, Wrapper } from '@screentone/core';

import { ReadOnlyTooltip } from 'components/context-menu-actions/shared/ReadOnlyTooltip';
import { useDataModelContext } from 'contexts/datamodel/useDataModel';
import { ArticleItem } from 'data/generated/graphql';
import { AllessehContent } from 'hooks/useAllessehContentQuery';
import { addExcludedContentToQuery } from 'utils/collection';

interface MoveQueryArticleToManualArticleProps {
  article: ArticleItem;
  hierarchyId: string;
  jsonQueryStr: string;
  allessehContent: AllessehContent;
  setJsonQueryStr: (newQueryStr: string) => void;
  disabled?: boolean;
}

export const MoveQueryArticleToManualArticle = ({
  article,
  hierarchyId,
  jsonQueryStr,
  allessehContent,
  setJsonQueryStr,
  disabled = false
}: MoveQueryArticleToManualArticleProps) => {
  const { insertEntity } = useDataModelContext();

  const handleExclude = () => {
    if (jsonQueryStr) {
      const parsedJsonQuery = addExcludedContentToQuery(allessehContent.data.id, jsonQueryStr);
      setJsonQueryStr(JSON.stringify(parsedJsonQuery));
    }
  };

  const handleMove = () => {
    handleExclude();
    insertEntity(hierarchyId, article);
  };

  return (
    <Wrapper>
      <ReadOnlyTooltip disabled={disabled}>
        <Button tertiary icon={IconArrowUp} onClick={handleMove} disabled={disabled}>
          Move to Top of List
        </Button>
      </ReadOnlyTooltip>
    </Wrapper>
  );
};
